import React from 'react';
import { FooterStyled, CookiePolicy } from './Footer.styled';

const Footer = () => (
  <FooterStyled>
    <CookiePolicy><a href='https://www.codecomputerlove.com/cookie-policy' target="_blank" rel='noopener noreferrer'>Cookie Policy</a></CookiePolicy>
  </FooterStyled>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js